export default __webpack_public_path__ + "static/media/focus2big_thumb.2cba9315.jpg";